import React, { Suspense, lazy } from "react";
import { Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

import "moment/locale/de";

import { FORMAT_DATE_MOMENT } from "../../common/dateFormats";
import Spinner from "../spinner/Spinner";

import "./DateField.scss";

const DateInput = lazy(() => import("./LazyDateInput"));

function DateField({
  name,
  value,
  minDate,
  maxDate,
  label,
  error,
  placeholderTransKey,
  clearable,
  required,
  setFieldValue
}) {
  const { t } = useTranslation();

  return (
    <div className="field">
      <Suspense fallback={<Spinner />}>
        <DateInput
          className="fitKiel-date-input"
          localization="de"
          name={name}
          label={label}
          placeholder={t(placeholderTransKey)}
          value={value}
          popupPosition="bottom left"
          clearable={clearable !== false}
          required={required}
          autoComplete="off"
          initialDate={minDate} // workaround @see https://github.com/arfedulov/semantic-ui-calendar-react/issues/120
          minDate={minDate}
          maxDate={maxDate}
          dateFormat={FORMAT_DATE_MOMENT}
          closable={true}
          onChange={(_, { value }) => {
            setFieldValue(name, value);
          }}
        />
        {error && <Message error content={error} />}
      </Suspense>
    </div>
  );
}

export default React.memo(DateField);
